import { KeysOf, ValueOf } from '~types/common';

type FontWeightKeys = KeysOf<typeof fontWeight>;

export type FontWeight = {
  [key in FontWeightKeys]: ValueOf<typeof fontWeight>;
};

const fontWeight = {
  bold: 600,
  normal: 400,
};

export default fontWeight;
